import { render, staticRenderFns } from "./ttAndIcbu.vue?vue&type=template&id=ff74d638&scoped=true"
import script from "./ttAndIcbu.vue?vue&type=script&lang=js"
export * from "./ttAndIcbu.vue?vue&type=script&lang=js"
import style0 from "./ttAndIcbu.vue?vue&type=style&index=0&id=ff74d638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff74d638",
  null
  
)

export default component.exports